module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-default skin",
    class: ("skin-" + _vm.skin)
  }, [_c('cover-book', {
    staticClass: "cover",
    attrs: {
      "cover": _vm.livre && _vm.livre.couverture
    }
  }), _c('div', {
    staticClass: "coverplace"
  }), (_vm.livre) ? [_c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "titre b f5 mb2"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.livre.titre, 38)))]), _c('h6', {
    staticClass: "subtitl auteurs f6"
  }, [_c('b', [_vm._v(_vm._s(_vm.auteurs))])]), _c('div', {
    staticClass: "desc content",
    domProps: {
      "innerHTML": _vm._s(_vm.livre.description)
    }
  })]), _vm._t("default", null, {
    livre: _vm.livre
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5011a4da"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/presentation/book-default.vue
// module id = 1362
// module chunks = 1